import React, { Component } from 'react'
// import { Bar, BarChart, CartesianGrid, Cell, Legend, Line, LineChart, Pie, PieChart, ResponsiveContainer, Sector, Tooltip, XAxis, YAxis } from 'recharts'

import Rainbow from 'rainbowvis.js'
import {
  BarChartByAttributeRatio,
  BarChartByDoubleAttributeRatio,
  PieChartByAttribute,
  Timeline,
  TimelineByAttribute,
  TimelineByTwoAttributes,
  TimelineOfDifferentAttributes,
} from '../shared/Charts'

export default class ReportCharts extends Component {


  render() {
    const rp = this.props.report
    const isPrint = this.props.isPrint

    let operators = undefined
    if (rp.isReportGroup) {
      operators = rp.reports.map(r => r.operatorName)
    }

    const chartContainerStyle = {
      backgroundColor: isPrint ? '#f2f2f7' : 'white',
      borderRadius: '25px',
      paddingTop: '10px',
    }

    const renderPieSST = (aspectRatio) => {
      return (
        <div className="column has-text-centered">
          <div style={chartContainerStyle}>
            <p className="subtitle mb-0 is-size-6">Consumo por Subestação de Tracção (kWh)</p>
            <PieChartByAttribute
              data={rp.readings}
              groupAttribute={'sst'}
              sumAttribute={'consumptionTotal'}
              aspectRatio={aspectRatio}
            />
          </div>
        </div>
      )
    }

    const renderPieMotora = (aspectRatio) => {
      return (
        <div className="column has-text-centered">
          <div style={chartContainerStyle}>
            <p className="subtitle mb-0 is-size-6">Consumo por Frota (kWh)</p>
            <PieChartByAttribute
              data={rp.readings}
              groupAttribute={'fleetGroup'}
              sumAttribute={'consumptionTotal'}
              aspectRatio={aspectRatio}
            />
          </div>
        </div>
      )
    }

    const renderPieOperador = (aspectRatio) => {
      return (
        <div className="column has-text-centered">
          <div style={chartContainerStyle}>
            <p className="subtitle mb-0 is-size-6">Consumo por Operador (kWh)</p>
            <PieChartByAttribute
              data={rp.readings}
              groupAttribute={'operatorName'}
              sumAttribute={'consumptionTotal'}
              aspectRatio={aspectRatio}
            />
          </div>
        </div>
      )
    }

    const renderTimeline = () => {
      return (
        <div style={chartContainerStyle} className="mt-5">
          <p className="subtitle mb-3 is-size-6 ml-6">Consumo vs Frenagem Diário Global (kWh)</p>

          <TimelineOfDifferentAttributes
            data={rp.readings}
            attributes={[
              { name: 'consumptionTotal', label: 'Consumo' },
              { name: 'brakingTotal', label: 'Frenagem' },
            ]}
            aspectRatio={5}
          />
        </div>
      )
    }

    const renderTimelineByOperador = () => {
      return (
        <div style={chartContainerStyle} className="mt-5">
          <p className="subtitle mb-3 is-size-6 ml-6">Consumo Diário por Operador (kWh)</p>
          <TimelineByAttribute
            data={rp.readings}
            year={rp.year}
            month={rp.month}
            groupbyAttribute={'operatorName'}
            sumAttribute={'consumptionTotal'}
            aspectRatio={5}
          />
        </div>
      )
    }

    const renderTimelineByOperadorBraking = () => {
      return (
        <div style={chartContainerStyle} className="mt-5">
          <p className="subtitle mb-3 is-size-6 ml-6">Frenagem Diária por Operador (kWh)</p>
          <TimelineByAttribute
            data={rp.readings}
            year={rp.year}
            month={rp.month}
            groupbyAttribute={'operatorName'}
            sumAttribute={'brakingTotal'}
            aspectRatio={5}
          />
        </div>
      )
    }

    const renderBarMwhKmFleet = (aspectRatio) => {
      return (
        <div style={chartContainerStyle} className="mt-5">
          <p className="subtitle mb-3 is-size-6 ml-6">Consumo por Quilómetro por Frota (kWh/km)</p>
          <BarChartByAttributeRatio
            data={rp.readings}
            groupAttribute={'fleetGroup'}
            numeratorAttribute={'consumptionTotal'}
            denominatorAttribute={'kmTraveled'}
            label={'kWh/km'}
            aspectRatio={aspectRatio}
          />
        </div>
      )
    }

    const renderBarMwhKmFleet2 = (aspectRatio) => {
      return (
        <div style={chartContainerStyle} className="mt-5">
          <p className="subtitle mb-3 is-size-6 ml-6">
            Consumo vs Frenagem por Quilómetro por Frota (kWh/km)
          </p>
          <BarChartByDoubleAttributeRatio
            data={rp.readings}
            groupAttribute={'fleetGroup'}
            numeratorAttribute1={'consumptionTotal'}
            numeratorAttribute2={'brakingTotal'}
            denominatorAttribute={'kmTraveled'}
            numerator1DisplayName={'Consumo'}
            numerator2DisplayName={'Frenagem'}
            label={''}
            aspectRatio={aspectRatio}
          />
        </div>
      )
    }
    

    const renderBarMwhKmOperator = (aspectRatio) => {
      return (
        <div className="column has-text-centered">
          <div style={chartContainerStyle}>
            <p className="subtitle mb-0 is-size-6">Consumo médio por Quilómetro por Operador (kWh/km)</p>
            <BarChartByAttributeRatio
              data={rp.readings}
              groupAttribute={'operatorName'}
              numeratorAttribute={'consumptionTotal'}
              denominatorAttribute={'kmTraveled'}
              label={'kWh/km'}
              aspectRatio={aspectRatio}
            />
          </div>
        </div>
      )
    }

    const renderConsumoFrenagem = (aspectRatio, operatorName = undefined) => {
      return (
        <div key={operatorName} style={chartContainerStyle} className="mt-5">
          <p className="subtitle mb-3 is-size-6 ml-6">
            Consumo vs Frenagem Diário {operatorName ? operatorName : 'Global'} (kWh)
          </p>
          {/* <TimelineByTwoAttributes
            data={rp.readings}
            sumAttribute1={'consumptionTotal'}
            sumAttribute2={'brakingTotal'}
            aspectRatio={aspectRatio}
            total
          /> */}
          <TimelineOfDifferentAttributes
            data={rp.readings}
            attributes={[
              { name: 'consumptionTotal', label: 'Consumo' },
              { name: 'brakingTotal', label: 'Frenagem' },
            ]}
            filters={operatorName && [{ attribute: 'operatorName', value: operatorName }]}
            aspectRatio={aspectRatio}
            // total
          />
        </div>
      )
    }

    const renderConsumoPeriodo = (aspectRatio) => {
      return (
        <div style={chartContainerStyle} className="mt-5">
          <p className="subtitle mb-3 is-size-6 ml-6">
            Consumo vs Frenagem Diário por Período Horário (kWh)
          </p>
          <TimelineOfDifferentAttributes
            data={rp.readings}
            attributes={[
              { name: 'consumptionVazio', label: 'Vazio' },
              { name: 'consumptionSuperVazio', label: 'SuperVazio' },
              { name: 'consumptionPontas', label: 'Pontas' },
              { name: 'consumptionCheias', label: 'Cheias' },
            ]}
            aspectRatio={aspectRatio}
          />
        </div>
      )
    }

    if (rp.isReportGroup) {
      const pieAspectRatio = 2
      return (
        <>
          <div className="section">
            <div className="columns is-centered is-vcentered my-0">
              {renderPieOperador(2.5)}
              {renderBarMwhKmOperator(2.5)}
            </div>

            <div className="columns is-centered is-vcentered my-0">
              {renderPieSST(2.5)}
              {renderPieMotora(2.5)}
            </div>
            {/* {renderBarMwhKmFleet2(5)} */}
            {renderTimeline()}
            {renderTimelineByOperador()}
            {renderTimelineByOperadorBraking()}

            {operators.map(op => renderConsumoFrenagem(5, op) )}

            {/* {renderConsumoPeriodo(5)} */}
          </div>
        </>
      )
    } else {
      const pieAspectRatio = 2.5
      return (
        <div className="section">
          <div className="columns is-centered is-vcentered my-0">
            {renderPieSST(2.5)}
            {renderPieMotora(2.5)}
          </div>
          {/* {renderBarMwhKmFleet2(5)} */}
          {/* {renderTimeline()} */}
          {renderConsumoFrenagem(5)}
          {/* {renderConsumoPeriodo(5)} */}
        </div>
      )
    }
  }
}
